import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { MultiOfferModel, partnersBrandAssetsPath } from 'client/data/models/multi-offer';
// eslint-disable-next-line venom/no-internal-modules
import { BRANDS_LIST } from 'site-modules/multi-offer/constants/brands';
// eslint-disable-next-line venom/no-internal-modules
import { BrandLogo } from 'site-modules/multi-offer/components/shared/brand-logo/brand-logo';
import { PartnerLogoGrid } from 'site-modules/shared/components/partner-logo-grid/partner-logo-grid';

import './appraisal-promotions-partners.scss';

export function AppraisalPromotionsPartnersUI({ brandAssetsByPartner = {} }) {
  return (
    <div className="appraisal-promotions-partners">
      <div className="pos-r text-center mb-2">
        <h2 className="title d-inline-block bg-white px-0_5 px-md-3 fw-medium">Our partners</h2>
        <div className="gradient-line-background w-100 pos-a" />
      </div>
      <PartnerLogoGrid
        brandsList={BRANDS_LIST}
        brandAssetsByPartner={brandAssetsByPartner}
        logoHeight={24}
        LogoComponent={BrandLogo}
        rowClassName="justify-content-center justify-content-md-around mb-1_5"
      />
    </div>
  );
}

AppraisalPromotionsPartnersUI.propTypes = {
  brandAssetsByPartner: PropTypes.shape({}),
};

export const stateToPropsConfig = {
  brandAssetsByPartner: bindToPath(() => partnersBrandAssetsPath.build(), MultiOfferModel),
};

export const AppraisalPromotionsPartners = connectToModel(AppraisalPromotionsPartnersUI, stateToPropsConfig);
